import * as React from 'react';

const IconSquiggle2 = (props) => (
    <svg
        {...props}
        fill='none'
        height={415}
        viewBox='0 0 1006 415'
        width={1006}
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M546.623 34.6921C653.944 -11.7063 825.351 -11.7672 1005.62 35.7361L993.233 82.7458C817.844 36.5288 658.951 39.0913 565.915 79.3142C519.856 99.2272 493.264 126.75 484.767 158.906C476.197 191.337 484.111 235.623 523.063 293.126C543.419 323.176 557.188 345.649 563.539 361.428C566.334 368.371 570.05 379.385 567.321 390.551C565.664 397.33 561.723 403.76 555.276 408.255C549.386 412.36 543.173 413.618 538.662 413.978C530.207 414.654 521.328 412.613 514.282 410.614C506.589 408.431 497.816 405.293 488.532 401.77C469.125 394.406 447.577 385.45 420.985 375.792C331.947 343.451 209.529 312.305 92.5293 366.554H0.0693359L0 366.465C155.873 245.976 330.239 291.109 437.582 330.098C464.116 339.736 488.595 349.797 505.78 356.318C505.906 356.366 506.031 356.413 506.155 356.461C500.419 346.944 492.757 335.066 482.815 320.389C439.712 256.758 424.202 197.822 437.767 146.487C451.404 94.8778 492.504 58.0896 546.623 34.6921Z'
            fill='#FC5200'/>
    </svg>
);

export default IconSquiggle2;
